import { areUserRolesIn } from '../../../../../helpers';
import { Roles, SupervisionNoteStatus } from '../../../../../constants';

import type { IParentSupervision } from '../../../../../utils/types';

interface ShowButtonVisibility {
  showDeleteButton: boolean;
  showEditButton: boolean;
  showBackdateForm: boolean;
  isStartDisabled: boolean;
}

export function getButtonVisibilityValues(
  parentSupervision: IParentSupervision | null,
  userRoles: Roles[],
  submitting: boolean,
  hasPersistedSupervision: boolean,
  values: IParentSupervision,
  timeToolTipOpen: boolean,
  durationToolTipOpen: boolean,
  userEmail?: string,
): ShowButtonVisibility {
  const showDeleteButton =
    !areUserRolesIn(userRoles, [Roles.LimitedAccessGuardian]) &&
    !!parentSupervision?.id &&
    (parentSupervision.status === SupervisionNoteStatus.Editing ||
      parentSupervision.status === SupervisionNoteStatus.Started) &&
    (parentSupervision?.bcba.email === userEmail || areUserRolesIn(userRoles, [Roles.Admin]));

  const showEditButton =
    areUserRolesIn(userRoles, [Roles.Admin]) &&
    !!parentSupervision?.id &&
    parentSupervision.status === SupervisionNoteStatus.Completed;

  const showBackdateForm =
    areUserRolesIn(userRoles, [Roles.Admin]) &&
    !!parentSupervision?.id &&
    (parentSupervision.status === SupervisionNoteStatus.Editing ||
      parentSupervision.status === SupervisionNoteStatus.Started);

  const isStartDisabled =
    submitting ||
    hasPersistedSupervision ||
    !values?.client?.id ||
    !values?.expected_duration ||
    !values?.location ||
    !values?.date_start ||
    !values?.setting ||
    timeToolTipOpen ||
    durationToolTipOpen;

  return {
    showDeleteButton,
    showEditButton,
    showBackdateForm,
    isStartDisabled,
  };
}
